import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/plan/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/plan/save`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/plan/findById?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  remove({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/plan/remove?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  batchRemove({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/plan/batchRemove`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  listExamAnalysis({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/plan/listExamAnalysis`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  exportList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'post',
          url: '/examination/plan/exportList',
          data: params,
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportPlanInfoList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'post',
          url: '/examination/plan/exportPlanInfoList',
          data: params,
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
